/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCFunnelStatusChangedBySource } from './TCFunnelStatusChangedBySource';
/**
 * TSOA-compatible version of FunnelStatusHistoryDocument.
 * Replaces Zod-inferred type with explicit type for TSOA compatibility.
 */
export type TCFunnelStatusHistoryDocument = {
    createdAt: string;
    updatedAt: string;
    id: string;
    tenantId?: string;
    contactId?: string;
    funnelConversationId?: string;
    sessionId?: string;
    fromStatusId?: number;
    toStatusId?: number;
    changedAt?: string;
    modelType: TCFunnelStatusHistoryDocument.modelType;
    funnelId?: string;
    archivedAt?: string | null;
    eventSequence?: number;
    eventTimestamp?: string;
    actor: {
        userId?: string | null;
        type: TCFunnelStatusChangedBySource;
    };
};
export namespace TCFunnelStatusHistoryDocument {
    export enum modelType {
        STATUS_HISTORY = 'StatusHistory',
    }
}

